"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIosVersionFromUserAgent = void 0;
const _1 = require("./");
function getIosVersionFromUserAgent(userAgent) {
    // Parses the major and minor version off the user agent data and converts it into a number
    const platformVersionMatchArray = userAgent.match(/OS (\w+)/) || [];
    (0, _1.invariant)(platformVersionMatchArray.length === 2, 'iOS version not found in provided user agent.');
    const platformVersion = platformVersionMatchArray[1];
    const platformVersionAsArray = platformVersion.split('_');
    const platformMajorVersion = parseInt(platformVersionAsArray[0]);
    const platformMinorVersion = parseInt(platformVersionAsArray[1]);
    const platformPatchVersion = parseInt(platformVersionAsArray[2]) || 0;
    return {
        major: platformMajorVersion,
        minor: platformMinorVersion,
        patch: platformPatchVersion,
    };
}
exports.getIosVersionFromUserAgent = getIosVersionFromUserAgent;
//# sourceMappingURL=get_ios_version_from_user_agent.js.map